// extracted by mini-css-extract-plugin
export var chevronIcon = "_aq-2";
export var teamName = "_aq-1";
export var teamSwitcherButton = "_aq-0";